import { configureStore } from '@reduxjs/toolkit'
// ----Grey---
import LoginReducer from './Slice/login/loginSlice';
import GreyDashboard from './Slice/Grey/GreyDashboard/GreyDashboardSlice';
import GroupInwardReport from './Slice/Grey/GroupInwardReport/GroupInwardReportSlice';
import PartyProfile from './Slice/Grey/PartyProfile/PartyProfileSlice';

// ---FAS---
import TrialBalance from './Slice/Fas/Financial Statement/Trial Balance/TrialBalanceSlice';
import Ledger from './Slice/Fas/Financial Statement/Ledger/LedgerSlice';
import BalanceSheet from './Slice/Fas/Financial Statement/BalanceSheet/BalanceSheetSlice';
import ProfitAndLoss from './Slice/Fas/Financial Statement/Profit And Loss/ProfitAndLossSlice';
import FundAndFlow from './Slice/Fas/Financial Statement/Fund And Flow/FundAndFlow';
import Customer from './Slice/Fas/Profile Analysis/Customer/CustomerSlice';
import Supplier from './Slice/Fas/Profile Analysis/Supplier/SupplierSlice';
import Bank from './Slice/Fas/DayBook Analysis/Bank/BankSlice';
import Purchase from './Slice/Fas/DayBook Analysis/Purchase/PurchaseSlice';
import Sale from './Slice/Fas/DayBook Analysis/Sale/SaleSlice';
import ReceivablePayble from './Slice/Fas/ReceivablePayble/ReceivablePaybleSlice';

import PayRoll from './Slice/PayRoll/PayRollSlice'

import InwardAnylysis from './Slice/Colour/InwardAnylysis/InwardAnylysis'

import Maintenance from './Slice/Maintenance/MaintenanceSlice'
import Millstage from './Slice/Millstage/MillstageSlice';
import OrderApprovalReducer from './Slice/OrderApprovel/OrderApprovalSlice';
import UserRightSlice from './Slice/UserRight/UserRightSlice';
import CollectionManSlice from './Slice/CollectionMan/CollectionManSlice';
import WebAuthnReducer from './Slice/WebAuthn/WebAuthnSlice';

import MillstageEntryslice from './Slice/MillstageEntry/MillstageEntrySlice';





export default configureStore({
  reducer: {
    // ---Grey---
    ClientLogin: LoginReducer,
    GreyDashboardSlice: GreyDashboard,
    GroupInwardReportSlice: GroupInwardReport,
    PartyProfileSlice: PartyProfile,

    // ---FAS---
    LedgerSlice: Ledger,
    TrialBalanceSlice: TrialBalance,
    BalanceSheetSlice: BalanceSheet,
    ProFitAndLossSlice: ProfitAndLoss,
    FundFlowSlice: FundAndFlow,
    CustomerSlice: Customer,
    SupplierSlice: Supplier,
    BankSlice: Bank,
    PurchaseSlice: Purchase,
    SaleSlice: Sale,
    ReceivablePaybleSlice: ReceivablePayble,

    MaintenanceSlice: Maintenance,

    PayRollSlice: PayRoll,

    InwardAnylysisSlice: InwardAnylysis,
    MaintenanceSlice: Maintenance,
    MillstageSlice: Millstage,
    OrderApprovalSlice: OrderApprovalReducer,
    UserRightSlice: UserRightSlice,
    CollectionManSlice: CollectionManSlice,
    WebAuthn: WebAuthnReducer,
    MillstageEntry: MillstageEntryslice





  },
})
